module.exports = __webpack_public_path__ + "media/images/flags/AS-cc78b279db15280a62acb7a5787fca9c.svg";